import { Component, EventEmitter, Input, Output, OnInit, ChangeDetectorRef } from '@angular/core';
import { TextToggleData } from 'src/app/components/text-toggle/text-toggle.component';
import { JoiPage } from 'src/app/store/permissions.era';
import { JoiEvent } from 'src/app/store/events.era';
import { Wrapper } from 'src/app/components/wrapper.component';
import { PageGroup, PageGroupHandle, pageGroupHandleBySubpageHandle } from 'globals/store/permissions.data';
import { groupsByHandleReselector } from '../../store/reselectors/permissions.reselector';
import { CommonModule } from '@angular/common';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { IconTextComponent } from 'src/app/components/buttons/icon-text.component';
import { JoiNavWrapper } from 'src/app/components/wrappers/joi-nav-wrapper.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'top-menu',
    template: `
<div class="menu_items desktop">
  <div class="group" *ngIf="!!event && !!openPage">
      <ng-container *ngFor="let item of userGroupsByHandle[pageGroupHandleBySubpageHandle[openPage.handle]]?.pages || []">
        <a *ngIf="{ active: openPage.handle === item.handle } as vars"
          class="menu_item smooth" (click)="vars.active ? null : goToPage($event, item)" 
          [routerLink]="'/' + item.url + '/' + event.eventId" [ngClass]="{ active: vars.active }">
          {{ item.label }}
        </a>
      </ng-container>
  </div>
  <div class="controls_container" >
    <div style="flex:1"></div>
    <ng-content select=".top-menu-mid-right"></ng-content>
    <div class="edit-visible" *ngIf="!!totalItems" (click)="editVisible.emit()">
      <label>EDIT VISIBLE</label>
      <div class="count">{{ visibleItems }} / {{ totalItems }}</div>
    </div>

    <div class="toggle-menu" *ngIf="!!toggleData && toggleData.loaded">
      <div class="label">View:</div> 
      <joi-nav-wrapper *ngIf="!!toggleData && toggleData.loaded"
        class="icon-tabs"
        [menuItems]="programSizeIcons"
        [onlyIcons]="true"
        [iconMap]="programSizeIconMap"
        [menuMap]="programSizeMenuMap"
        [selectedId]="toggleData.leftSelected ? 'narrow' : 'wide'" 
        (selectItem)="$event === (toggleData.leftSelected ? 'narrow' : 'wide') ? null : toggle()"
      ></joi-nav-wrapper>
    </div>
    <icon-text [active]="filtered" *ngIf="showFilter" (click)="filter.emit()"></icon-text>
    <div *ngIf="showZoom" class="control room">
        <icon (click)="uiService.zoomClick(1)" matIcon="remove"></icon>
        <span class="zoom_percent">{{100 - uiService.zoom_amount/2}}%</span>
        <icon (click)="uiService.zoomClick(-1)" matIcon="add"></icon>
    </div>
    <div *ngIf="showPrint" class="control" (click)="manualPrint ? print.emit() : doPrint()"><icon matIcon="print"></icon></div>
  </div>
</div>
    `,
    styleUrls: [`./top.menu.scss`, '../../components/menu/edit-visible.scss'],
    standalone: true,
    imports: [CommonModule, IconComponent, IconTextComponent, JoiNavWrapper, RouterLink]
})
export class TopMenuComponent extends Wrapper<TopMenuComponent> implements OnInit {
    @Input() toggleData: TextToggleData = null
    @Input() showZoom = false
    @Input() showPrint = false
    @Input() showFilter = false
    @Input() filtered = false;
    @Input() visibleItems: number
    @Input() totalItems: number
    @Input() manualPrint = false

    @Output() filter: EventEmitter<void> = new EventEmitter()
    @Output() editVisible: EventEmitter<void> = new EventEmitter()
    @Output() print: EventEmitter<void> = new EventEmitter()

    openPage: JoiPage
    event: JoiEvent
    menu_items:JoiPage[] = []
    programSizeIcons = [ 'narrow', 'wide' ]
    programSizeMenuMap = { wide: 'Wide View', narrow: 'Narrow View' }
    programSizeIconMap = { wide: 'WIDE', narrow: 'NARROW' }
    userGroupsByHandle: { [K in PageGroupHandle]: PageGroup } = {} as any
    pageGroupHandleBySubpageHandle = pageGroupHandleBySubpageHandle

    constructor(private changeDetectorRef: ChangeDetectorRef) {
      super()
    }

    toggle() {
      this.toggleData.toggleNotifier()
    }

    selectProgramSize(data) {
      console.log(data)
    }

    ngOnInit(){
      this.subProp(this.store.select('events','event'), 'event')
      this.setZoom()
      this.subCallback(this.store.select('permissions', 'openGroup'), group => this.menu_items = !group ? [] : group.pages)
      this.subProp(this.store.select('permissions', 'openPage'), 'openPage')
      this.selectCallback<{ [K in PageGroupHandle]: PageGroup }, any>(groupsByHandleReselector, null, userGroupsByHandle => {
        this.userGroupsByHandle = userGroupsByHandle
        this.changeDetectorRef.detectChanges()
      })
    }

    goToPage(event, page:JoiPage) {
      // console.log({ event })
      if (event.shiftKey || event.ctrlKey || event.metaKey) return
      // console.log("Calling to perf to start " + page.traceName)
      // this.performanceService.start(page.traceName)
    }

    setZoom(){
      if(this.settingsService.bank.user.zoom){
        this.uiService.zoom_amount = this.settingsService.bank.user.zoom;
        this.uiService.updateZoomAmount(this.settingsService.bank.user.zoom, true);
      }
    }

    doPrint() {
        this.uiService.print()
    }

}

